import { render } from "./IFSOrderLineTable.vue?vue&type=template&id=28252323&scoped=true"
import script from "./IFSOrderLineTable.vue?vue&type=script&lang=js"
export * from "./IFSOrderLineTable.vue?vue&type=script&lang=js"

import "./IFSOrderLineTable.vue?vue&type=style&index=0&id=28252323&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28252323"],['__file',"src/components/Orders/OrdersSummary/IFSOrder/IFSOrderLineTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28252323"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28252323', __exports__)) {
    api.reload('28252323', __exports__)
  }
  
  module.hot.accept("./IFSOrderLineTable.vue?vue&type=template&id=28252323&scoped=true", () => {
    api.rerender('28252323', render)
  })

}


export default __exports__